import React, { ReactNode } from 'react';
import styles from './NavBar.module.css';
import { Container, Row, Col } from 'react-bootstrap';
import { NavList } from 'components/NavList';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { User } from 'model';

export type NavBarProps = {
  onLogout: () => void,
  user?: User,
  isMobile: boolean,
  onItemClick?: () => void,
}

export type LogoMenuContainerProps = {
  isMobile: boolean,
  children: ReactNode,
};

export const LogoMenuContainer = (props: LogoMenuContainerProps) => {
  if (!props.isMobile) {
    return (
      <Container className={classnames(styles.logoMenuContainer)}>
        {props.children}
      </Container>
    )
  } else {
    return (
      <>
        {props.children}
      </>
    )
  }
}

export const NavBar = (props: NavBarProps) => {
  const { t } = useTranslation();

  return (
    <Container fluid className={classnames(
      styles.root,
      { [styles.fixed]: !props.isMobile },
      { [styles.navbarFlex]: !props.isMobile },
      { [styles.mobile]: props.isMobile },
    )}>
      <LogoMenuContainer isMobile={props.isMobile}>
        <Row>
          <Col className={classnames(styles.logoWrapper, { [styles.mobileHidden]: props.isMobile })}>
            <a href='/'>
              <img alt="Flo Multi-Unit Dashboard" src="/images/MoenSmartLogo.png" />
            </a>
          </Col>
        </Row>
        <Row><Col className={styles.welcome}><span>{t('welcome')} {props.user?.firstName}</span></Col></Row>


        <Row className={styles.navListContainer}>
          <Col>
            <NavList onItemClick={props.onItemClick} />
          </Col>
        </Row>
      </LogoMenuContainer>

      <Row className={classnames(
        { [styles.logoutMobile]: props.isMobile },
        { [styles.logoutDesktop]: !props.isMobile },
      )}>
        <Col>
          <svg width="24" height="24" viewBox="3 3 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M13.5 6V11C13.5 11.5523 13.0523 12 12.5 12C11.9477 12 11.5 11.5523 11.5 11V6C11.5 5.44772 11.9477 5 12.5 5C13.0523 5 13.5 5.44772 13.5 6ZM15.8 8.89956C16.2 8.49956 16.8 8.39956 17.2 8.79956C18.7 10.0996 19.5 11.9996 19.5 13.9996C19.5 17.8996 16.4 20.9996 12.5 20.9996C8.6 20.9996 5.5 17.8996 5.5 13.9996C5.5 11.9996 6.4 10.0996 7.9 8.79956C8.3 8.49956 8.9 8.49956 9.3 8.89956C9.6 9.29956 9.6 9.89956 9.2 10.2996C8.1 11.1996 7.5 12.5996 7.5 13.9996C7.5 16.7996 9.7 18.9996 12.5 18.9996C15.3 18.9996 17.5 16.7996 17.5 13.9996C17.5 12.5996 16.9 11.1996 15.9 10.2996C15.5 9.89956 15.4 9.29956 15.8 8.89956Z" fill="#909CA5"/>
          </svg>
          <span className={styles.logout} onClick={() => { props.onLogout() }}>
            {t('logout')}
          </span>
        </Col>
      </Row>
    </Container>
  );
};

export default NavBar;
